import { DatePickerField, type OperationType } from '@/components';
import { useProjectFormContext } from '@/features/project/_hooks/form-context';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  operation: OperationType;
  onChange: () => void;
};

export const FiscalYearField: FC<Props> = ({ operation, onChange }) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useProjectFormContext();

  return (
    <DatePickerField
      required
      name="data.fiscalYear"
      label={t('created-fiscal-year')}
      control={control}
      errors={errors}
      picker="year"
      disabled={operation === 'edit'}
      wrapperStyle={{ marginBottom: 0 }}
      fieldStyle={{ width: '100%' }}
      shouldCoexistOnChange
      onChange={onChange}
    />
  );
};
